// MedplumClient con auto-batch que NO deja colgadas las lecturas cuando el lote falla.
//
// Causa (@medplum/core 5.1.x, `executeAutoBatch`): con 2+ lecturas encoladas se hace `await this.post(fhirBaseUrl, bundle)` SIN try/catch. Si el servidor
// responde un error a TODO el lote (p. ej. el 403 `sin_vinculo_asistencial` del proxy, que no es un Bundle), `post` lanza y ninguna de las promesas
// individuales (`readResource`, `useResource`...) se resuelve ni se rechaza: la pantalla queda en el spinner y la consola muestra «Uncaught (in promise)».
// Con una sola lectura sí rechaza bien, por eso solo falla cuando hay varias en la misma ventana de `autoBatchTime`.
//
// `executeAutoBatch` es `private` en los tipos, así que no se hereda: se envuelve en la instancia (la llama un setTimeout vía `this.executeAutoBatch()`).
import { MedplumClient, type MedplumClientOptions } from '@medplum/core';

type EntradaLote = { reject: (reason: unknown) => void };
type ConLote = { autoBatchQueue?: EntradaLote[]; executeAutoBatch: () => Promise<void> };

export function crearMedplumClient(opciones: MedplumClientOptions): MedplumClient {
  const cliente = new MedplumClient(opciones);
  const interno = cliente as unknown as ConLote;
  const original = interno.executeAutoBatch.bind(cliente);
  interno.executeAutoBatch = async () => {
    // La cola se vacía dentro del original antes de la petición: se toma copia ahora.
    const pendientes = interno.autoBatchQueue ? [...interno.autoBatchQueue] : [];
    try {
      await original();
    } catch (err) {
      // Rechazar cada lectura con el mismo error (no-op si alguna ya se resolvió) y no propagar: nadie espera esta promesa.
      for (const p of pendientes) p.reject(err);
    }
  };
  return cliente;
}
